import fitnessTraining1 from "../assets/home4.png";
import fitnessTraining2 from "../assets/home3.png";
import fitnessTraining3 from "../assets/home2.png";

// Home Swiper Images
import homeSwiperImh1 from "../assets/s1.jpg";
import homeSwiperImh2 from "../assets/s2.jpg";

// Trainers Data Images
import trainer1 from "../assets/tr2.png";
import trainer2 from "../assets/tr1.png";
import trainer3 from "../assets/tr3.png";

// The Story Behind Our Gym imege
import story from "../assets/about5.png";

// allOurTrainersData Images
import ourTrainer1 from "../assets/home4.png";
import ourTrainer2 from "../assets/home2.png";
import ourTrainer3 from "../assets/home3.png";
import ourTrainer4 from "../assets/classes2.png";
import ourTrainer5 from "../assets/classes3.png";
import ourTrainer6 from "../assets/classes4.png";

import ourTrainers1 from "../assets/tr1.png";
import ourTrainers2 from "../assets/tr2.png";
import ourTrainers3 from "../assets/tr3.png";
import ourTrainers4 from "../assets/trainers2.png";
import ourTrainers5 from "../assets/trainers3.png";
import ourTrainers6 from "../assets/trainers4.png";

import blogArticle1 from "../assets/blog2.png";
import blogArticle2 from "../assets/blog3.png";
import blogArticle3 from "../assets/blog4.png";
import blogArticle4 from "../assets/blog5.png";
import blogArticle5 from "../assets/blog6.png";
import blogArticle6 from "../assets/blog7.png";

// Small Images
import thumbnail1 from "../assets/blog8.png";
import thumbnail2 from "../assets/blog9.png";
import thumbnail3 from "../assets/blog10.png";
import thumbnail4 from "../assets/blog11.png";
import thumbnail5 from "../assets/blog12.png";
import thumbnail6 from "../assets/blog13.png";

// certificates
import cert1 from "../elagpt/c1.jpg";
import cert2 from "../elagpt/c2.jpg";
import cert3 from "../elagpt/c3.jpg";
import cert4 from "../elagpt/c4.jpg";
import cert5 from "../elagpt/c5.jpg";
import cert6 from "../elagpt/c6.jpg";
import cert7 from "../elagpt/10.png";
import cert8 from "../elagpt/11.png";
import cert9 from "../elagpt/12.png";
import cert10 from "../elagpt/13.png";
import cert11 from "../elagpt/14.png";

export const headerLinksData = [
  {
    id: 1,
    title: "Home",
    to: "/",
  },
  {
    id: 2,
    title: "About the Instructor",
    to: "/about",
  },
  {
    id: 3,
    title: "Classes",
    to: "/classes",
  },
  {
    id: 6,
    title: "Contact",
    to: "/contact",
  },
];

export const fitnessTrainingData = [
  {
    id: 1,
    title: "Pilates Training",
    description: "containing Lorem Ipsum passage sand more recently with",
    image: fitnessTraining1,
    to: "/yogaClass",
  },

  {
    id: 2,
    title: "Aerobic Training",
    description: "containing Lorem Ipsum passage sand more recently with",
    image: fitnessTraining2,
    to: "/",
  },

  {
    id: 3,
    title: "CrossFit Workout",
    description: "containing Lorem Ipsum passage sand more recently with",
    image: fitnessTraining3,
    to: "/",
  },
];

export const homeSwiperData = [
  {
    id: 1,
    name: "Nattasha",
    title: "Athletics /Trainer",
    image: homeSwiperImh1,
    description: `There are many variations of passages of Lorem Ipsum
                    available, but the majority have suffered alteration in some
                    form, by injected humour`,
  },

  {
    id: 2,
    name: "Nattasha",
    title: "Athletics /Trainer",
    image: homeSwiperImh2,
    description: `There are many variations of passages of Lorem Ipsum
                    available, but the majority have suffered alteration in some
                    form, by injected humour`,
  },

  {
    id: 3,
    name: "Nattasha",
    title: "Athletics /Trainer",
    image: homeSwiperImh1,

    description: `There are many variations of passages of Lorem Ipsum
                    available, but the majority have suffered alteration in some
                    form, by injected humour`,
  },

  {
    id: 4,
    name: "Nattasha",
    title: "Athletics /Trainer",
    image: homeSwiperImh1,
    description: `There are many variations of passages of Lorem Ipsum
                    available, but the majority have suffered alteration in some
                    form, by injected humour`,
  },
];

export const trainersData = [
  {
    id: 1,
    nam: "Amanda",
    title: "Crosscut Expert, Nutrition & Rehab",
    image: trainer1,
    to: "https://www.linkedin.com/in/the-mustafa-khaled/",
  },

  {
    id: 2,
    nam: "Madison Froning",
    title: "Crosscut Expert, Nutrition & Rehab",
    image: trainer2,
    to: "https://www.linkedin.com/in/the-mustafa-khaled/",
  },

  {
    id: 3,
    nam: "Joshua Frankilin",
    title: "Crosscut Expert, Nutrition & Rehab",
    image: trainer3,
    to: "https://www.linkedin.com/in/the-mustafa-khaled/",
  },
];

export const gymAmenitiesData = [
  {
    id: 1,
    title: "Lockers",
    description: "Secure lockers that work by you choosing a four digit code.",
  },
  {
    id: 2,
    title: "Changing Rooms",
    description: `  Delicious, protein-packed gourmet shakes that come in chocolate,
              fruit, vanilla and more. Water and snacks too.`,
  },

  {
    id: 3,
    title: "Fuel Bar",
    description: `Mini towels for class and lovely big towels for showers after
              class. *Amenities may not be available at all studios`,
  },

  {
    id: 4,
    title: "Complimentary Towels",
    description: "Secure lockers that work by you choosing a four digit code.",
  },

  {
    id: 5,
    title: "Wifi & Restrooms",
    description: "Secure lockers that work by you choosing a four digit code.",
  },

  {
    id: 6,
    title: "Hot Showers & Hair Care",
    description: `what your body craves in the morning, you're not alone. The
              majority of people crank the handle all the way up.`,
  },
];

export const ourPlansData = [
  {
    id: 1,
    title: "Basic",
    offer: "$25 / month",
    description: "30% Off for Beginners",
    icon: "fa-solid fa-heart",
  },
  {
    id: 2,
    title: "Standard",
    offer: "$35 / month",
    description: "Most popular",
    icon: "fa-solid fa-star",
  },

  {
    id: 3,
    title: "Premium",
    offer: "$50 / month",
    description: "10% Off for Yoga Class",
    icon: "fa-solid fa-gem",
  },
];

export const articlesNewsData = [
  {
    id: 1,
    about: "Fitness",
  },

  {
    id: 2,
    about: "Health",
  },

  {
    id: 3,
    about: "Nutrition",
  },
];

export const gymStoryData = [
  {
    id: 1,
    welcome: "Welcome",
    title: "The Story Behind Our Gym",
  },

  {
    id: 2,
    title: "Story",
    image: story,
  },
  {
    id: 3,
    title: "Our Mission",
  },

  {
    id: 4,
    title: "Our Value",
  },
];

export const valuesBoxes = [
  {
    id: 1,
    icon: "fa-regular fa-newspaper",
    title: "Certified trainer",
  },
  {
    id: 2,
    icon: "fa-solid fa-apple-whole",
    title: "Nutrition & diet",
  },

  {
    id: 3,
    icon: "fa-solid fa-person",
    title: "Years of experience",
  },
];

export const valuesNumbers = [
  {
    id: 1,
    number: "10+",
    description: "Year of Experience",
  },

  {
    id: 2,
    number: "500+",
    description: "Happy Clients",
  },

  {
    id: 3,
    number: "50+",
    description: "Expert Trainers",
  },

  {
    id: 4,
    number: "15k",
    description: "Instagram followers",
  },
];

export const allOurTrainersData = [
  {
    id: 1,
    title: "Pilates Training",
    image: ourTrainer1,
    to: "/yogaClass",
  },

  {
    id: 2,
    title: "CrossFit",
    image: ourTrainer2,
    to: "/",
  },

  {
    id: 3,
    title: "Aerobic",
    image: ourTrainer3,
    to: "/",
  },

  {
    id: 4,
    title: "Yoga As Therapy",
    image: ourTrainer4,
    to: "/",
  },

  {
    id: 5,
    title: "Boxing",
    image: ourTrainer5,
    to: "/",
  },

  {
    id: 6,
    title: "Energy Dance",
    image: ourTrainer6,
    to: "/",
  },
];

export const certificateData = [
  {
    id: 1,
    title: "Pilates Training",
    image: cert1,
    to: "/yogaClass",
  },

  {
    id: 2,
    title: "CrossFit",
    image: cert2,
    to: "/",
  },

  {
    id: 3,
    title: "Aerobic",
    image: cert3,
    to: "/",
  },

  {
    id: 4,
    title: "Yoga As Therapy",
    image: cert4,
    to: "/",
  },

  {
    id: 5,
    title: "Boxing",
    image: cert5,
    to: "/",
  },

  {
    id: 6,
    title: "Energy Dance",
    image: cert6,
    to: "/",
  },
  {
    id: 7,
    title: "Energy Dance",
    image: cert7,
    to: "/",
  },
  {
    id: 8,
    title: "Energy Dance",
    image: cert8,
    to: "/",
  },
  {
    id: 9,
    title: "Energy Dance",
    image: cert9,
    to: "/",
  },
  {
    id: 10,
    title: "Energy Dance",
    image: cert10,
    to: "/",
  },
  {
    id: 11,
    title: "Energy Dance",
    image: cert11,
    to: "/",
  },
];

export const ourTrainers = [
  {
    id: 1,
    image: ourTrainers1,
    name: "Madison Fronting",
  },

  {
    id: 2,
    image: ourTrainers2,
    name: "Joshua Frankilin",
  },

  {
    id: 3,
    image: ourTrainers3,
    name: "Miranda",
  },
  {
    id: 4,
    image: ourTrainers4,
    name: "Steve Smith",
  },
  {
    id: 5,
    image: ourTrainers5,
    name: "Kane Lucy",
  },
  {
    id: 6,
    image: ourTrainers6,
    name: "Jhon Willson",
  },
];

export const blogArticlesNewsData = [
  {
    id: 1,
    title: "The 10 best exercises to do in your park",
    name: "Jacob Cornish",
    image: blogArticle1,
    thumbnail: thumbnail1,
  },
  {
    id: 2,
    title: "How to Choose The Right Equipment For You",
    name: "Benjamin Gray",
    image: blogArticle2,
    thumbnail: thumbnail2,
  },
  {
    id: 3,
    title: "How to Maximum Time Spent at the Gym",
    name: "David Ferguson",
    image: blogArticle3,
    thumbnail: thumbnail3,
  },

  {
    id: 4,
    title: "Simple Condition for all Around Fitness.",
    name: "William Wilkins",
    image: blogArticle4,
    thumbnail: thumbnail4,
  },

  {
    id: 5,
    title: "How to Modify any Program to Improve Your Weakness",
    name: "Benjamin Gray",
    image: blogArticle5,
    thumbnail: thumbnail5,
  },

  {
    id: 6,
    title: `The Beginner’s Guide to Weight Lifting`,
    name: "Bernadette",
    image: blogArticle6,
    thumbnail: thumbnail6,
  },
];

export const contactInfoData = [
  {
    id: 1,
    title: "Phone",
    icon: "fa-solid fa-phone",
    cta: "91 9818166461",
  },
  {
    id: 2,
    title: "Email",
    icon: "fa-solid fa-envelope",
    cta: "contact@fitwithela.in",
  },

  {
    id: 3,
    title: "Location",
    icon: "fa-solid fa-location-dot",
    cta: "Delhi",
  },
];
